export default function MainLoader() {
  return (
    <div id="loader" className="firstLoader">
      <div className="preloader">
        <div className="preloader-spin"></div>
      </div>
    </div>
  );
}
